import { WEAHomeTemplate } from '../../components/Templates/WEA/WEAHomeTemplate';

const WEAHomeScreen: React.FC = () => {
  return <WEAHomeTemplate />;
};

export default WEAHomeScreen;
